import { reactive } from "vue";

type ToastType = "success" | "error" | "info";

export type ToastItem = {
  id: number;
  type: ToastType;
  message: string;
};

const toasts = reactive<ToastItem[]>([]);
let toastId = 0;

export const getErrorMessage = (
  error: unknown,
  fallback = "Có lỗi xảy ra. Vui lòng thử lại.",
) => {
  const err = error as any;
  const data = err?.response?.data;

  if (typeof data === "string" && data.trim()) return data;
  if (data?.message) return String(data.message);
  if (data?.Message) return String(data.Message);
  if (Array.isArray(data?.errors)) return data.errors.join(", ");
  if (data?.errors && typeof data.errors === "object") {
    return Object.values(data.errors).flat().join(", ");
  }
  if (err?.response?.status) {
    return `Yêu cầu thất bại với mã ${err.response.status}.`;
  }
  if (err?.message) return String(err.message);

  return fallback;
};

export const useToast = () => {
  const removeToast = (id: number) => {
    const index = toasts.findIndex((item) => item.id === id);
    if (index >= 0) toasts.splice(index, 1);
  };

  const showToast = (message: string, type: ToastType = "info") => {
    const id = ++toastId;
    toasts.push({ id, type, message });
    window.setTimeout(() => removeToast(id), 3200);
  };

  return { toasts, showToast, removeToast };
};
